module.exports = __webpack_public_path__ + "static/media/sixsense-gallery-1.6881c89e.jpg";